import React from 'react';
import createForm from "./Form";
import ComponentField from "../../form/ComponentField";
import CheckBox from '../../form/CheckBox';
import TypeTextEditor from '../../form/TypeTextEditor';
import Figures from 'src/components/form/Figures';
import Select from 'src/components/form/Select';

class OptInFormForm extends React.Component {

    render() {
        return (
            <form onSubmit={this.props.handleSubmit}>
                <div className="row form-row">
                    <div className="col-sm-1">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name={this.props.componentConfig.idfield}
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="Kód"
                            disabled={true}
                        />
                    </div>
                    <div className="col-sm-3">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name="name"
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="Megnevezés"
                        />
                    </div>
                    <div className="col-md-4">
                        <Select
                            component="OptIn"
                            storeType="local"
                            label="OptIn"
                            name="optins"
                            objectValue={false}
                            labelKey="name"
                            value={this.props.values.optins}
                            saveChanges={this.props.setFieldValue}
                            {...this.props.getFieldProps("optins")}
                            isMulti={true}
                        />
                    </div>
                    <div className="col-md-4">
                        <Select
                            component="OptInSource"
                            storeType="local"
                            label="Forrás"
                            name="optinsource"
                            objectValue={false}
                            labelKey="name"
                            value={this.props.values.optinsource}
                            saveChanges={this.props.setFieldValue}
                            {...this.props.getFieldProps("optinsource")}
                        />
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-sm-4">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name="button_label"
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="Gomb felirata"
                        />
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-sm-12">
                        <TypeTextEditor
                            name="description"
                            label="Leírás"
                            data={this.props.values}
                            componentConfig={this.props.componentConfig}
                            getFieldProps={this.props.getFieldProps}
                            setFieldValue={this.props.setFieldValue}
                        />
                    </div>
                </div>
                {this.props.values[this.props.componentConfig.idfield] && <div className="row form-row">
                    <div className="col-sm-12">
                        <Figures name="figures" label="Képek" component={this.props.componentConfig.componentname}
                                    componentId={this.props.values[this.props.componentConfig.idfield]}/>
                    </div>
                </div>}
            </form>
        );
    }
}

export default createForm(OptInFormForm);
